import { createSelector } from 'reselect'

import { getPaidUsersWithoutLimits } from 'common/userRoles/selectors/paidUsersSelectors'
import { getAccountUsers } from 'common/userRoles/selectors/userRolesSelectors'
import { sortUsersByUserRole } from 'common/userRoles/userRolesHelpers'
import { Group } from 'shared/api/requests/groups/schemas'

export const getGroupsItems = (state: RootState) => state.groups.items

export const getSortedUsersByGroupId = createSelector(
  [getGroupsItems, getAccountUsers, (state: RootState, groupId: number) => groupId],
  (groups, users, groupId) => {
    const userIdsInGroup = groups?.find((group) => group.group_id === groupId)?.user_ids
    const usersInGroup = (users || []).filter((user) => userIdsInGroup?.includes(user.user_id))

    return sortUsersByUserRole(usersInGroup)
  },
)

export const getAllGroupsUsersIds = createSelector(getGroupsItems, (groups) =>
  groups?.reduce<number[]>((acc, group) => acc.concat(group.user_ids), []),
)

export const getGroupsPaidUsersWithoutLimits = createSelector(
  [getAllGroupsUsersIds, getPaidUsersWithoutLimits],
  (allGroupsUsersIds, paidUsersWithoutLimits) =>
    paidUsersWithoutLimits?.filter((user) => allGroupsUsersIds?.includes(user.user_id)),
)

export const getIsGroupsFetching = (state: RootState) => state.groups.isFetching
export const getIsGroupCreating = (state: RootState) => state.groups.isCreatingGroup
export const getIsGroupFetchingAutoAssign = (state: RootState) => state.groups.isFetchingAutoAssign
export const getIsChangingUsersInGroup = (state: RootState) => state.groups.isChangingUsersInGroup
export const getIsGroupNameFetching = (state: RootState) => state.groups.isGroupNameFetching

export const getAutoAssignGroups = createSelector([getGroupsItems], (groups): Group[] => {
  if (!groups) return []

  return groups.filter((group) => group.auto_assign_enabled)
})

export const getGroupsForAssigneePicker = createSelector(
  [getAutoAssignGroups],
  (groups): Array<Group & { value: number }> =>
    groups.map((group) => ({ ...group, value: group.group_id })),
)
